var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 37,
    viewBox: "0 0 32 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 2.75V5H20.25V2.75C20.25 1.55469 21.2344 0.5 22.5 0.5C23.6953 0.5 24.75 1.55469 24.75 2.75V5H28.125C29.9531 5 31.5 6.54688 31.5 8.375V11.75H0V8.375C0 6.54688 1.47656 5 3.375 5H6.75V2.75C6.75 1.55469 7.73438 0.5 9 0.5C10.1953 0.5 11.25 1.55469 11.25 2.75ZM0 14H31.5V33.125C31.5 35.0234 29.9531 36.5 28.125 36.5H3.375C1.47656 36.5 0 35.0234 0 33.125V14ZM23.0625 21.9453C23.7656 21.3125 23.7656 20.2578 23.0625 19.5547C22.4297 18.9219 21.375 18.9219 20.7422 19.5547L14.0625 26.3047L10.6875 22.9297C10.0547 22.2969 9 22.2969 8.36719 22.9297C7.66406 23.6328 7.66406 24.6875 8.36719 25.3203L12.8672 29.8203C13.5 30.5234 14.5547 30.5234 15.1875 29.8203L23.0625 21.9453Z",
    fill: "#4BB218"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCheck);
export default __webpack_public_path__ + "static/media/CalendarCheck.0fc89b305535aa4ce58759403500c4c1.svg";
export { ForwardRef as ReactComponent };